import React from "react";
import { Tabs } from "antd";

function StyledTabContainer({ children, style, ...props }) {
  return (
    <>
      {children && (
        <div style={{ ...WIDGET_STYLE, ...style }} class={"widget-tabs-r"}>
          <div {...props}>{children}</div>
        </div>
      )}
    </>
  );
}

const WIDGET_STYLE = {
  position: "absolute",
  right: 40,
  top: 82,
  width: 400,
  background: "rgba(255, 255, 255, 0.8)",
  borderRadius: 6,
  zIndex: 1,
};

export default StyledTabContainer;
